import { observable, action, computed } from 'mobx';

export interface ISearchPagination {
    recsPerPage: number;
    totalNumRecs: number;
    firstRecNum: number;
    lastRecNum: number;
    link: string;
}

export class SearchPaginationCatalog {
    @observable public numberOfPages: number;
    @observable public numberOfCurrentPage: number;
    @observable public viewAllLink: string;
    @observable public previousPageLink: string;
    @observable public nextPageLink: string;

    @action
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public searchPagination(data: any) {
        const pagination: ISearchPagination = {
            recsPerPage: data.pagination.recsPerPage,
            totalNumRecs: data.pagination.totalNumRecs,
            firstRecNum: data.pagination.firstRecNum,
            lastRecNum: data.pagination.lastRecNum,
            link: data.pagination.link
        };

        if (pagination.recsPerPage) {
            this.numberOfPages = Math.ceil(pagination.totalNumRecs / pagination.recsPerPage);
            this.numberOfCurrentPage = Math.ceil(pagination.firstRecNum / pagination.recsPerPage);
            this.viewAllLink = '';
            this.previousPageLink = '';
            this.nextPageLink = '';

            if (this.numberOfPages > 1) {
                this.viewAllLink = pagination.link
                    .replace(/%7Boffset%7D/g, '0')
                    .replace(/%7BrecordsPerPage%7D/g, pagination.totalNumRecs.toString());
            }
            if (this.numberOfCurrentPage > 1) {
                const offset = pagination.firstRecNum - pagination.recsPerPage - 1;
                this.previousPageLink = pagination.link
                    .replace(/%7Boffset%7D/g, offset.toString())
                    .replace(/%7BrecordsPerPage%7D/g, pagination.recsPerPage.toString());
            }
            if (this.numberOfCurrentPage < this.numberOfPages) {
                const offset = pagination.firstRecNum + pagination.recsPerPage - 1;
                this.nextPageLink = pagination.link
                    .replace(/%7Boffset%7D/g, offset.toString())
                    .replace(/%7BrecordsPerPage%7D/g, pagination.recsPerPage.toString());
            }
        }
    }

    @computed
    public get hasMoreResults() {
        return this.nextPageLink ? true : false;
    }
}
